export default __webpack_public_path__ + "static/media/Group9240.f9c09421.svg";